import React,{Component}from 'react';
import { Animation } from 'rsuite';

const { Slide } = Animation;


const classList=["nav-content",
                "nav-content menuContent-move-right",
                "nav-content menuContent-move-left"
            ]
class SlideContent extends Component {
    checkName(){
        if(this.props.id===this.props.currentMenu && this.props.menuOpen){
            return true;
        }
        else{
            return false;
        }
    }
    render(){
        //const menuOpen=this.props.menuOpen;
        const menuId=this.props.id;
        //const currentMenu=this.props.currentMenu;
        return(
            <Slide in={this.checkName()} placement='left'>
            <div className="nav-content" style={{left:'60px'}} id={menuId}>
                <div className="nav-con-close" >
                    <h2 className='icon' >
                        {this.props.content}
                    </h2>
                    {this.props.children}  
                </div>
            </div>
            </Slide>
        );
    }
}

export default SlideContent;